import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../../services/api';
import { sse } from '../../../services/sse';
import { userId } from '../../../services/TokenData';
import {
    Container,
    NotificationContainer,
    Title,
    BackgroundClose,
    Content,
    AlertWrapper,
    AlertDateTime,
    AlertContent,
    RemoveAlertIcon,
} from './style';
import { HiTrash } from 'react-icons/hi';
import { TokenPerfil } from '../../../services/TokenData';

const Alertas = ({ Show, setShow, NaoVisualizados, setNaoVisualizados }) => {
    const [Alertas, setAlertas] = useState(null);
    const [Reload, setReload] = useState(false);
    const Navigate = useNavigate();

    const VizualizarAlerta = (id) => {
        api.patch(`/alertas/visualizar/${id}`)
            .then(() => {
                setReload(!Reload);
                if (NaoVisualizados > 0) {
                    setNaoVisualizados(NaoVisualizados - 1);
                }
            })
            .catch((error) => {
                console.error('Erro ao visualizar alerta:', error);
            });
    };

    function deleteAlert(id) {
        api.delete(`alertas/${id}`, {
            data: { id_usuario_acao: userId() },
        })
            .then((res) => {
                setReload(!Reload);
                if (NaoVisualizados > 0) {
                    setNaoVisualizados(NaoVisualizados - 1);
                }
            })
            .catch((error) => {
                console.error('Erro ao deletar alerta:', error);
            });
    }

    useEffect(() => {
        function Request() {
            api.get(`/alertas/${userId()}`)
                .then((res) => {
                    setAlertas(res.data.alertas);
                })
                .catch((error) => {
                    console.error('Erro ao buscar alertas:', error);
                });
        }
        Request();
    }, [Reload]);

    sse.addEventListener('message', () => {
        setReload(!Reload);
    });

    return (
        <Container Show={Show}>
            <BackgroundClose onClick={(e) => setShow(false)} Show={Show} />
            <Content Empty={!Alertas?.length}>
                <Title Empty={!Alertas?.length}>Sem Notificações</Title>
                {Alertas?.slice()
                    .reverse()
                    .map((d) => (
                        <NotificationContainer
                            key={d?.id}
                            seen={d?.visualizada}
                            onClick={() => {
                                !!d?.visualizada || VizualizarAlerta(d?.id);
                                if (TokenPerfil() === 'GESTOR') {
                                    Navigate(`/gestor/processo`, {
                                        state: {
                                            IdOcorrencia: d?.id_processo,
                                        },
                                    });
                                } else if (TokenPerfil() === 'OPERADOR') {
                                    Navigate(`/operador/processo`, {
                                        state: {
                                            IdProcesso: d?.id_processo,
                                        },
                                    });
                                }
                            }}
                        >
                            <AlertWrapper>
                                <AlertDateTime>
                                    <h4>
                                        {new Date(d?.data_alerta).toLocaleDateString('pt-BR', {
                                            day: '2-digit',
                                            month: '2-digit',
                                            year: 'numeric',
                                        })}
                                    </h4>
                                    <h4>
                                        {new Date(d?.data_alerta).toLocaleTimeString('pt-BR', {
                                            hour: '2-digit',
                                            minute: '2-digit',
                                        })}
                                    </h4>
                                </AlertDateTime>

                                <AlertContent>
                                    <h3>
                                        {!!d?.seq_ocorrencia
                                            ? `Processo: ${d?.numero} Seq: ${d?.seq_ocorrencia || d?.id_processo}${d?.nivel_ocorrencia !== 0 && d?.nivel_ocorrencia ? `.${d?.nivel_ocorrencia}` : ''}`
                                            : `Processo: ${d?.numero}`}
                                    </h3>
                                    <span>{d?.justificativa_solicitacao || null}</span>
                                    <span>
                                        {!!d?.quantidade_dias
                                            ? `Dias solicitados: ${d?.quantidade_dias}`
                                            : !d?.seq_ocorrencia && !d?.id_solicitacao
                                              ? `A situação do processo foi alterada.`
                                              : d?.nivel_ocorrencia !== 0 && d?.nivel_ocorrencia
                                                ? `Foi atribuída uma nova subocorrência`
                                                : `Foi atribuída uma nova ocorrência`}
                                    </span>
                                </AlertContent>

                                <RemoveAlertIcon
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        deleteAlert(d?.id);
                                    }}
                                >
                                    <HiTrash />
                                </RemoveAlertIcon>
                            </AlertWrapper>
                        </NotificationContainer>
                    ))}
            </Content>
        </Container>
    );
};
export default Alertas;
